export enum LocalStorageKeys {
    ProfileState = 'profile_state',
    Language = 'lang',
    FirstLogin = 'first_login',
}
